export default __webpack_public_path__ + "static/media/node-logo.3d9157a9.png";